// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + "app" + ".css?v=" + "220ab3dc9a3c5c9dfc0e" + "";
};